module.exports = __webpack_public_path__ + "static/media/1.720c5558.svg";